import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./CompletionPage.css";
import { Loader2 } from "lucide-react";
import MobileTopBar from "../../components/MobileTopBar";
import DesktopTopBar from "../../components/DesktopTopBar";
import { useGlobalAlert } from "../../context/AlertContext";
import { registerUser } from "../../services/authService";
import { createDogProfile } from "../../services/dogService";
import apiClient from "../../api/apiClient";
import { setUserData, setUserId, fetchUserData } from "../../redux/userSlice";

const HalfOnboardingPage = ({ formData, setFormData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { triggerAlert } = useGlobalAlert();

  const fcmToken = useSelector((state) => state.user.fcmToken);
  const profile = useSelector((state) => state.user.profile);

  const handleContinueOnboarding = () => {
    setFormData((prev) => ({
      ...prev,
      dogPersonalityOrigin: "half-onboarding",
    }));

    if (formData.team === "social" || profile?.user_dog_status === 0) {
      navigate("/team-social-checklist", { state: { step: 1 } });
    } else {
      navigate("/dog-personality", {
        state: {
          step: 2,
          fromHalfCompleted: true,
        },
      });
    }
  };

  const handleStartExploring = async () => {
    navigate("/dashboard-switcher");
  };

  return (
    <div className="completion-container">
      <MobileTopBar
        onBack={() => navigate("/onboarding-tutorial")}
        backColor="#000"
        logoColor="#009fd9"
        blueLogo="true"
        isProtectedRoute={false}
      />
      <DesktopTopBar
        showBack={true}
        onBack={() => navigate("/onboarding-tutorial")}
        backColor="#000"
        showProgress={false}
      />

      {/* Main Content */}
      <div className="completion-content">
        <div className="completion-buttons" style={{ gap: "1rem" }}>
          <button
            className="completion-button button-gap"
            onClick={handleContinueOnboarding}
          >
            CONTINUE BUILDING PROFILE
          </button>
          <button className="completion-button" onClick={handleStartExploring}>
            START EXPLORING
          </button>
        </div>
      </div>
    </div>
  );
};

export default HalfOnboardingPage;
